__turbopack_context__.v({
  "aspectRatio": "aspectratio-module-scss-module__kxA6La__aspectRatio",
  "clip": "aspectratio-module-scss-module__kxA6La__clip",
  "ratio-lg-16-9": "aspectratio-module-scss-module__kxA6La__ratio-lg-16-9",
  "ratio-lg-4-3": "aspectratio-module-scss-module__kxA6La__ratio-lg-4-3",
  "ratio-md-16-9": "aspectratio-module-scss-module__kxA6La__ratio-md-16-9",
  "ratio-md-4-3": "aspectratio-module-scss-module__kxA6La__ratio-md-4-3",
  "ratio-nav-tablet-16-9": "aspectratio-module-scss-module__kxA6La__ratio-nav-tablet-16-9",
  "ratio-nav-tablet-4-3": "aspectratio-module-scss-module__kxA6La__ratio-nav-tablet-4-3",
  "ratio-sm-16-9": "aspectratio-module-scss-module__kxA6La__ratio-sm-16-9",
  "ratio-sm-4-3": "aspectratio-module-scss-module__kxA6La__ratio-sm-4-3",
  "ratio-xl-16-9": "aspectratio-module-scss-module__kxA6La__ratio-xl-16-9",
  "ratio-xl-4-3": "aspectratio-module-scss-module__kxA6La__ratio-xl-4-3",
});
